
import { useState, useEffect, useRef } from 'react';
// import { addUserActivityStatus } from '../../services/actions/chat/activityStatusActions';
import { useCustomDispatch } from '../../hooks';
import { authToken } from '../../storage/authToken';
import { getActivityStatus } from '../../services/slices/chat/activityStatus';
import { useAuthSelector } from '../../services/selectors/authSelector';
// import { subscribeUserStatus } from '../../utils/miscellaneous/ably';

const ActivityTracker = () => {

	const dispatch = useCustomDispatch()
	const token = authToken()
	const { pharmacyId } = useAuthSelector()
	const idleTimerRef = useRef(null)

	const [activityStatus, setActivityStatus] = useState('online');

	const resetIdleTimer = () => {
		clearTimeout(idleTimerRef.current);
		idleTimerRef.current = setTimeout(() => {
			setActivityStatus('idle');
		}, 2 * 60 * 1000)
	};

	const handleActivity = () => {
		setActivityStatus('online');
		resetIdleTimer();
	};

	useEffect(() => {
		window.removeEventListener('mousemove', handleActivity)
		window.addEventListener('mousedown', handleActivity);
		window.addEventListener('click', handleActivity);
		window.addEventListener('keydown', handleActivity);

		resetIdleTimer();

		return () => {
			window.removeEventListener('mousemove', handleActivity)
			window.removeEventListener('mousedown', handleActivity);
			window.removeEventListener('click', handleActivity);
			window.removeEventListener('keydown', handleActivity);
			clearTimeout(idleTimerRef.current);
		};
	}, []);

	useEffect(() => {
		const activityInterval = activityStatus === 'idle'
			? 2 * 60 * 1000
			: 1 * 60 * 1000;

		const updateActivityStatus = () => {
			if (token && pharmacyId && activityStatus) {
				dispatch(getActivityStatus({ status: activityStatus, pharmacy_id: pharmacyId }));
			}
		};

		updateActivityStatus();

		const intervalId = setInterval(() => {
			updateActivityStatus();
		}, activityInterval);

		return () => clearInterval(intervalId);
	}, [activityStatus, dispatch, pharmacyId, token]);


	// useEffect(() => {
	// 	const ablyConnection = subscribeUserStatus(pharmacyId, dispatch)
	// 	return () => {
	// 		ablyConnection.close();
	// 	};

	// }, [pharmacyId])

	return null

};

export default ActivityTracker



